__turbopack_context__.v({
  "body": "cart-drawer-loading-module__nhWY1W__body",
  "cart-drawer-progress": "cart-drawer-loading-module__nhWY1W__cart-drawer-progress",
  "cart-drawer-spin": "cart-drawer-loading-module__nhWY1W__cart-drawer-spin",
  "indicator": "cart-drawer-loading-module__nhWY1W__indicator",
  "inline": "cart-drawer-loading-module__nhWY1W__inline",
  "label": "cart-drawer-loading-module__nhWY1W__label",
  "progress": "cart-drawer-loading-module__nhWY1W__progress",
  "root": "cart-drawer-loading-module__nhWY1W__root",
  "spinner": "cart-drawer-loading-module__nhWY1W__spinner",
});
